import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { Segment, TableWithImages, useMedia } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  fields: IField[];
  footer_text: Prismic.RichText;
  has_header: boolean;
}

interface IField {
  image: Prismic.Image;
  text_1: Prismic.RichText;
  text_2: Prismic.RichText;
  text_3: Prismic.RichText;
  text_4: Prismic.RichText;
  text_5: Prismic.RichText;
  isheader: boolean;
}

export const TableWithImagesContainer = ({
  fields,
  footer_text,
  has_header,
}: IProps) => {
  const isMobile = useMedia('sm');
  if (fields === null) {
    return null;
  }

  const header = fields.find((x) => x.isheader);
  return (
    <Segment>
      <TableWithImages>
        <table>
          {has_header && (
            <thead>
              <tr>
                <th></th>
                {!isMobile && <th>{Prismic.text(header?.text_1)}</th>}
                <th align="center">{Prismic.text(header?.text_2)}</th>
                <th align="center">{Prismic.text(header?.text_3)}</th>
                <th align="center">{Prismic.text(header?.text_4)}</th>
                <th align="center">{Prismic.text(header?.text_5)}</th>
              </tr>
            </thead>
          )}
          <tbody>
            {fields.map((item, index) => {
              if (item.isheader) {
                return <React.Fragment key={`tr-${index}`} />;
              } else {
                return (
                  <tr key={`tr-${index}`}>
                    {!isMobile && (
                      <td>
                        <img
                          src={item.image?.url}
                          width="155px"
                          alt={Prismic.text(item.text_1) ?? 'Mynd'}
                        />
                      </td>
                    )}
                    <td>
                      <PrismicText value={item.text_1} hyphenate />
                    </td>
                    <td>{Prismic.text(item.text_2)}</td>
                    <td>{Prismic.text(item.text_3)}</td>
                    <td>{Prismic.text(item.text_4)}</td>
                    <td>{Prismic.text(item.text_5)}</td>
                  </tr>
                );
              }
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={6}>{Prismic.text(footer_text)}</td>
            </tr>
          </tfoot>
        </table>
      </TableWithImages>
    </Segment>
  );
};
